import React from 'react';
import { ArrowRight } from 'lucide-react';
import { marqueeItems } from '../mock';
import { fallbackContent } from '../hooks/useContent';

const Hero = ({ hero = fallbackContent.hero }) => {
  const stats = hero.stats || [];
  return (
    <section id="home" className="relative pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <img src={hero.image} alt="Modern office" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#f5f5f8]/95 via-[#f5f5f8]/85 to-[#f5f5f8]/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="py-20 lg:py-28 max-w-3xl fade-up">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-white/70 border border-gray-200 mb-7">
            <span className="section-label text-[#12263f]">{hero.badge}</span>
          </div>

          <h1 className="font-display font-bold text-[#12263f] text-5xl md:text-6xl lg:text-7xl leading-[1.02]">
            {hero.title}
          </h1>

          <p className="mt-6 text-lg text-gray-600 max-w-xl leading-relaxed">{hero.subtitle}</p>

          <div className="mt-9 flex flex-wrap gap-4">
            <a href="#contact" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-[#12263f] text-white font-semibold hover:bg-[#1c3a5e] transition-all shadow-lg shadow-[#12263f]/20">
              Get in Touch
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#services" className="inline-flex items-center px-7 py-3.5 rounded-xl bg-white border border-gray-300 text-[#12263f] font-semibold hover:border-[#12263f] transition-all">
              Explore Services
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {stats.map((s, i) => (
              <div key={i}>
                <div className="font-display font-bold text-[#12263f] text-2xl lg:text-3xl leading-tight whitespace-pre-line">{s.value}</div>
                <div className="text-sm text-gray-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative bg-[#12263f] py-4 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...marqueeItems, ...marqueeItems].map((item, i) => (
            <span key={i} className="mx-8 text-sm font-semibold tracking-[0.2em] text-white/70 flex items-center gap-8">
              {item}
              <span className="text-[#c9a227]">•</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
